import { getAuth } from "firebase/auth";
import { child, get, increment, onValue, ref, set, update } from "firebase/database";
import { getFirebaseDatabase } from "./authHandler";



const getUID = () => getAuth().currentUser.uid

const generateAccountId = async (uid, cid) =>{
    // let accounts = await get(child(ref(getFirebaseDatabase()), `users/${uid}/accounts`))
    // if(accounts.exists()){
    //     let lastId = Object.keys(accounts.val()).at(-1).split("_").at(-1)
    //     console.log(lastId)
    //     return`ACT${new Date().getTime()}_${cid}_${+lastId+1}`
    // }else{
        return `ACT${new Date().getTime()}_${cid}`
    // }
   
}

const addDailyMetrics = (metrics) =>{
    const db = getFirebaseDatabase()
    const uid = getUID()
    return new Promise((resolve, reject)=>{
        if(uid != null){
            ref(db, `users/${uid}/dailyMetrics/${new Date().toISOString().split("T")[0]}`)
            .update({amount : increment(metrics.amount), count : increment(1)})
            .then(result=>{resolve(result)})
            .catch(err=>{reject(err)})
        }
    })
}


   
const generateCustomerId = async (uid) =>{
//     let customer = await get(child(ref(getFirebaseDatabase()), `users/${uid}/clients`))

//    if(customer.exists()){
//         let lastId = Object.keys(customer.val()).at(-1).split("_").at(-1)
//         return`DFC${new Date().getTime()}_${uid}_${+lastId+1}`
//     }else{
        return `DFC${new Date().getTime()}_${uid}`
    // }
}

export const signInUpdate = (uid, data) =>{
    const db = getFirebaseDatabase()
    set(ref(db, `users/${uid}/profileData`), data)
}

export const getProfileData = () => {
    const db = getFirebaseDatabase()
    const uid = getUID()
    return new Promise((resolve, reject) => {
        if(uid != null) {
            get(child(ref(db), `users/${uid}/profileData`)).then((snapshot) => {
                if (snapshot.exists()) {
                    resolve(snapshot.val())
                } else {
                    resolve({})
                }
            }).catch(reject)
        } else {
            reject("No user logged in")
        }
    })
}

export const updateProfileData = (data) => {
    const db = getFirebaseDatabase()
    const uid = getUID()
    return new Promise((resolve, reject) => {
        if(uid != null) {
            update(ref(db, `users/${uid}/profileData`), data).then(() => {
                resolve(true)
            }).catch(reject)
        } else {
            reject("No user logged in")
        }
    })
}

export const updateFinancierLegalConsent = (version) => {
    const db = getFirebaseDatabase()
    const uid = getUID()
    return new Promise((resolve, reject) => {
        if(uid != null) {
            update(ref(db, `users/${uid}/preferences/legal`), {
                legalAcceptedVersion: version,
                legalAcceptedAt: new Date().toISOString()
            }).then(() => {
                resolve(true)
            }).catch(reject)
        } else {
            reject("No user logged in")
        }
    })
}

export const updateCustomerLegalConsent = (phone, version) => {
    const db = getFirebaseDatabase()
    return new Promise((resolve, reject) => {
        if(phone) {
            update(ref(db, `global_customers/${phone}/legal`), {
                legalAcceptedVersion: version,
                legalAcceptedAt: new Date().toISOString()
            }).then(() => {
                resolve(true)
            }).catch(reject)
        } else {
            reject("No phone number provided")
        }
    })
}

export const addClient = (clientData) => {
    const db = getFirebaseDatabase()
    const uid = getUID()
    // generateClientId()
    return new Promise((resolve, reject)=>{
        if(uid != null){
        generateCustomerId(uid).then(newClientId=>{
            set(ref(db, `users/${uid}/clients/${newClientId}`), {...clientData, clientId : newClientId, isActive : true}).then(result=>{
                
                // DATA-FOR-ACCESS: If a contact number is provided, update the global registry
                if (clientData.contact && clientData.contact.length >= 10) {
                    const globalRef = ref(db, `global_customers/${clientData.contact}`);
                    update(globalRef, {
                        active_loans: increment(1),
                        lastUpdated: new Date().toISOString(),
                        [`financiers/${uid}`]: true
                    }).catch(e => console.error("Failed to update global customer registry", e));
                }

                resolve(result)
            })
        }).catch(err=>{
            reject(err)
        })
    } 
    })
    
}

export const addAccount = (cid, accountData) => {
    const db = getFirebaseDatabase()
    const uid = getUID()
    return new Promise((resolve, reject)=>{
        if(uid != null){
        generateAccountId(uid, cid).then(newAccountId=>{
            set(ref(db, `users/${uid}/accounts/${newAccountId}`), {...accountData, accountId : newAccountId, clientId: cid, isActive : true}).then(result=>{
                resolve({accountId:newAccountId})
            })
        }).catch(err=>{
            reject(err)
        })
    }
    })
}

export const addEntry = (accountId, entryData) =>{
    const db = getFirebaseDatabase()
    const uid = getUID()
    return new Promise((resolve, reject)=>{
        if(uid != null){
            set(ref(db, `users/${uid}/accounts/${accountId}/entries/ENT_${new Date().getTime()}`), entryData).then(result=>{
                resolve(result)
            }).catch(err=>{
                reject(err)
            })
        }
    })
}


export const setAccountStatus = (accountId, status) =>{
    const db = getFirebaseDatabase()
    const uid = getUID()
    return new Promise((resolve, reject)=>{
        if(uid != null){
            update(ref(db, `users/${uid}/accounts/${accountId}`), {isActive : status}).then(result=>{
                resolve(result)
            }).catch(err=>{
                reject(err)
            })
        }
    })
}

export const setCustomerStatus = (customerId, status) =>{
    const db = getFirebaseDatabase()
    const uid = getUID()
    return new Promise((resolve, reject)=>{
        if(uid != null){
            update(ref(db, `users/${uid}/clients/${customerId}`), {isActive : status}).then(result=>{
                resolve(result)
            }).catch(err=>{
                reject(err)
            })
        }
    })
}

// get data functions

export const getPreferences = () => {
    const db = getFirebaseDatabase()
    const uid = getUID()
    return new Promise((resolve, reject) => {
        try {
            onValue(ref(db, `users/${uid}/preferences`), prefs => {
                resolve(prefs.val() || {})
            })
        } catch(e) {
            reject(e)
        }
    })
}

export const updatePreferences = (prefs) => {
    const db = getFirebaseDatabase()
    const uid = getUID()
    return new Promise((resolve, reject) => {
        if(uid != null){
            update(ref(db, `users/${uid}/preferences`), prefs).then(result => {
                resolve(result)
            }).catch(err => {
                reject(err)
            })
        }
    })
}

export const getCustomersList =  () =>{
    const db = getFirebaseDatabase()
    const uid = getUID()
    return new Promise ((resolve, reject)=>{
       try{ onValue(ref(db,`users/${uid}/clients`), customerList=>{
            resolve(customerList.val())
        })}
        catch(e){
            reject(e)
        }
    })

}

const getCustomerProfileStatus = (uid, cid) =>{
    const db = getFirebaseDatabase()
    return new Promise((resolve, reject)=>{
        if(uid != null){
            get(child(ref(db), `users/${uid}/clients/${cid}/isActive`))
            .then(result=>{
                resolve(result.val())
            })
            .catch(err=>{
                reject(err)
            })
        }
    })
}



export const getAccountsList = async () =>{
    const db = getFirebaseDatabase()
    const uid = getUID()
    return new Promise((resolve, reject)=>{
        try{onValue(ref(db,`users/${uid}/accounts`), accountsList=>{
         resolve(accountsList.val())
        })}
        catch(e){
            reject(e)
        }
    })
    
}

export const getAccountEntries = async (accountId) =>{
    const db = getFirebaseDatabase()
    const uid = getUID()
    onValue(ref(db,`users/${uid}/account/${accountId}/entries`), entries=>{
        return entries.val()
    })
}

export const getAccountDetails = (accountId) => {
    const db = getFirebaseDatabase()
    const uid = getUID()

    return new Promise((resolve, reject)=>{
        try{
            onValue(ref(db,`users/${uid}/accounts/${accountId}`), accountData =>{
                resolve(accountData.val())
            })
        }catch(e){
            reject(e)
        }
    })
}

export const getcustomerDetails = (customerId) => {
    const db = getFirebaseDatabase()
    const uid = getUID()

    return new Promise((resolve, reject)=>{
        try{
            onValue(ref(db,`users/${uid}/clients/${customerId}`), customerData =>{
                resolve(customerData.val())
            })
        }catch(e){
            reject(e)
        }
    })
}

// Edit

export const editAccountDetail = (accountId, accountData)=>{
    const db = getFirebaseDatabase()
    const uid = getUID()

    return new Promise((resolve, reject)=>{
            update(ref(db, `users/${uid}/accounts/${accountId}`), accountData).then(result=>{
                resolve({updated:true, accountId})
            }).catch(err=>{
                reject(err)
            })
        
        
    })
}

export const editCustomerDetails = (customerId, customerData)=>{
    const db = getFirebaseDatabase()
    const uid = getUID()

    return new Promise((resolve, reject)=>{
        set(ref(db, `users/${uid}/clients/${customerId}`), {...customerData, clientId: customerId}).then(result=>{
            if (customerData.contact && customerData.contact.length >= 10) {
                const globalRef = ref(db, `global_customers/${customerData.contact}`);
                update(globalRef, {
                    lastUpdated: new Date().toISOString(),
                    [`financiers/${uid}`]: true
                }).catch(e => console.error("Failed to update global customer registry", e));
            }
            resolve({updated:true, customerId, result})
        }).catch(err=>{
            reject(err)
        })
    })
}

export const editEntry = (accountId, entryId , entryData) =>{
    const db = getFirebaseDatabase()
    const uid = getUID()

    return new Promise((resolve, reject)=>{
        set(ref(db, `users/${uid}/accounts/${accountId}/entries/${entryId}`), entryData ).then(result=>{
            resolve({updated:true, entryId, result})
        }).catch(err=>{
            reject(err)
        })
    })
}


// Delete 

export const deleteAccount = (accountId) =>{
    const db = getFirebaseDatabase()
    const uid = getUID()

    return new Promise((resolve, reject)=>{
        set(ref(db, `users/${uid}/accounts/${accountId}/isActive`), false).then(result=>{
            resolve({deleted:true, accountId})
        }).catch(err=>{
            reject(err)
        })
    })
}

export const deleteCustomer = (customerId) =>{
    const db = getFirebaseDatabase()
    const uid = getUID()

    return new Promise((resolve, reject)=>{
        set(ref(db, `users/${uid}/clients/${customerId}/isActive`), false).then(result=>{
            resolve({deleted:true, customerId})
        }).catch(err=>{
            reject(err)
        })
    })
}

export const permanentDeleteAccount = (accountId) => {
    const db = getFirebaseDatabase()
    const uid = getUID()

    return new Promise((resolve, reject)=>{
        set(ref(db, `users/${uid}/accounts/${accountId}`), null).then(result=>{
            resolve({deleted:true, accountId})
        }).catch(err=>{
            reject(err)
        })
    })
}

export const permanentDeleteCustomer = (customerId) => {
    const db = getFirebaseDatabase()
    const uid = getUID()

    return new Promise((resolve, reject)=>{
        set(ref(db, `users/${uid}/clients/${customerId}`), null).then(result=>{
            resolve({deleted:true, customerId})
        }).catch(err=>{
            reject(err)
        })
    })
}

export const deleteEntry = (accountId,entryId) =>{
    const db = getFirebaseDatabase()
    const uid = getUID()

    return new Promise((resolve, reject)=>{
        set(ref(db, `users/${uid}/accounts/${accountId}/entries/${entryId}`), null).then(result=>{
            resolve({deleted:true, entryId})
        }).catch(err=>{
            reject(err)
        })
    })
}

export const checkGlobalCredit = (mobileNumber) => {
    const db = getFirebaseDatabase();
    return new Promise((resolve, reject) => {
        get(child(ref(db), `global_customers/${mobileNumber}`))
            .then((snapshot) => {
                if (snapshot.exists()) {
                    resolve(snapshot.val());
                } else {
                    resolve(null);
                }
            })
            .catch(reject);
    });
};